import DocumentsTrashPage from './DocumentsTrashPage';
export default DocumentsTrashPage;